import { styled } from '@mui/material';

export const StyledDivider = styled('span')`
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  height: 16px;
  margin: 0 8px;
`;
